import React from 'react';
import PropTypes from 'prop-types';
import withWidth from '@material-ui/core/withWidth';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  appBar: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    height: 80
  },
  toolBar: {
    marginTop: 10,
    marginBottom: 10
  },
  linkStyle: {
    color: '#fff',
    textDecoration: 'none'
  },
});

class PrimarySearchAppBar extends React.Component {
  render () {
    const { classes, qtWindow } = this.props;

    return (
      <AppBar position="fixed" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <a href={qtWindow? "#": "/"} className={classes.linkStyle}>
              <img height="50px" src="/dg_static/website/images/chessify_logo_hz.png" alt="Chessify logo" />
            </a>
          </Toolbar>
        </AppBar>
    );
  }
}

PrimarySearchAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withWidth()(PrimarySearchAppBar));
